module.exports = __webpack_public_path__ + "media/images/home/app-store-751cddda000aa6f13a7743eb87815ab2.png";